<template>
	<div class="toolbar">
		<div class="toolbar__fields">
			<div class="toolbar__fieldBlock toolbar__projectFieldBlock">
				<div
					class="toolbar__fieldLabel"
					:style="{
						'margin-bottom': '5px',
					}"
				>
					{{ $t("Projeto") }}
				</div>

				<div class="flex align-items-center gap-17">
					<input
						class="toolbar__input"
						ref="projectInput"
						type="text"
						v-model="project"
						v-autowidth="{
							maxWidth: '960px',
							minWidth: '150px',
							comfortZone: 0,
						}"
						@blur="handleProjectInputBlur"
						@keydown.enter="(e) => e.target.blur()"
						maxlength="25"
						:disabled="!isProjectInEditMode"
					/>

					<BBtn
						variant="text"
						size="s"
						shape="circle"
						@click="handleProjectInputBtnClick"
						@mousedown="handleInpuBtnMousedown"
					>
						<BIcon :name="isProjectInEditMode ? 'Save' : 'Edit'" size="16px" />
					</BBtn>
				</div>
			</div>
			<div class="toolbar__fieldBlock">
				<div
					class="flex align-items-center"
					:style="{
						gap: '5px',
						'margin-bottom': '5px',
					}"
				>
					<div class="toolbar__fieldLabel">
						{{ $t("Simulação") }}
					</div>
					<StatusBadge
						v-if="simulation"
						class="toolbar__mobileStatusBadge"
						:status="calculationStatus"
					/>
				</div>

				<div class="flex align-items-center u-g17">
					<input
						class="toolbar__input"
						type="text"
						v-model="simulationName"
						v-autowidth="{
							maxWidth: '960px',
							minWidth: '150px',
							comfortZone: 0,
						}"
						maxlength="25"
						@blur="handleNameInputBlur"
						:disabled="!isNameInEditMode"
						@keydown.enter="(e) => e.target.blur()"
						ref="nameInput"
					/>

					<BBtn
						variant="text"
						size="s"
						shape="circle"
						@click="handleNameInputBtnClick"
						@mousedown="handleInpuBtnMousedown"
						class="toolbar__editBtn"
					>
						<BIcon :name="isNameInEditMode ? 'Save' : 'Edit'" size="16px" />
					</BBtn>

					<StatusBadge
						v-if="simulation"
						class="toolbar__desktopStatusBadge"
						:status="calculationStatus"
					/>
				</div>
			</div>
		</div>

		<BDropdown class="toolbar__mobileMenuDropdown">
			<template #toggle>
				<BBtn shape="circle">
					<BIcon name="OverflowVertical" size="20px" />
				</BBtn>
			</template>

			<BDropdownItem @click="handleEditDetailsClick">
				{{ $t("Alterar detalhes") }}
			</BDropdownItem>

			<BDropdownItem @click="handleDuplicateClick">
				{{ $t("Duplicar") }}
			</BDropdownItem>
			<BDropdownItem @click="handleDeleteClick">
				{{ $t("Apagar") }}
			</BDropdownItem>
		</BDropdown>

		<div class="toolbar__desktopBtns">
			<BBtn
				shape="circle"
				@click="handleDuplicateClick"
				:disabled="!originalSimulation"
			>
				<BIcon name="Duplicate" size="20px" />
			</BBtn>

			<BBtn shape="circle" @click="handleDeleteClick">
				<BIcon name="Delete" size="20px" />
			</BBtn>
		</div>

		<portal to="root">
			<SimulatorToolbarEditDetailsModal
				v-if="isEditDetailsModalOpen"
				:simulationName="simulationName"
				:project="project"
				@close="() => (isEditDetailsModalOpen = false)"
				@save="handleSaveDetails"
			/>
		</portal>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

import BBtn from "@/components/base/BBtn.vue";
import StatusBadge from "@/components/StatusBadge.vue";
import BIcon from "@/components/base/BIcon/index.vue";
import BSelect from "@/components/base/BSelect.vue";
import BDropdown from "@/components/base/BDropdown/BDropdown.vue";
import BDropdownItem from "@/components/base/BDropdown/BDropdownItem.vue";
import SimulatorToolbarEditDetailsModal from "./SimulatorToolbarEditDetailsModal.vue";

export default {
	components: {
		BBtn,
		BIcon,
		StatusBadge,
		BSelect,
		BDropdown,
		BDropdownItem,
		SimulatorToolbarEditDetailsModal,
	},
	data() {
		return {
			isNameInEditMode: false,
			isProjectInEditMode: false,
			selectedProject: null,
			isEditDetailsModalOpen: false,
			simulationName: "",
			project: "",
		};
	},
	computed: {
		...mapState("simulator", ["simulation"]),
		...mapGetters("simulator", ["originalSimulation"]),

		calculationStatus() {
			return this.originalSimulation
				? this.originalSimulation.calculationStatus
				: this.simulation.calculationStatus;
		},
	},
	methods: {
		...mapActions("simulations", ["duplicateSimulation", "deleteSimulation"]),

		...mapMutations("simulator", {
			setSimulationName: "setSimulationName",
			setSimulationProject: "setSimulationProject",
			storeDestroy: "destroy",
		}),

		...mapActions("simulator", {
			storeSave: "save",
			storeSaveMetadata: "saveMetadata",
		}),

		handleNameInputBtnClick() {
			this.isNameInEditMode = !this.isNameInEditMode;
			if (this.isNameInEditMode) {
				this.$nextTick(() => {
					this.$refs.nameInput.focus();
				});
			}
		},
		handleProjectInputBtnClick() {
			this.isProjectInEditMode = !this.isProjectInEditMode;
			if (this.isProjectInEditMode) {
				this.$nextTick(() => {
					this.$refs.projectInput.focus();
				});
			}
		},

		handleInpuBtnMousedown(e) {
			e.preventDefault();
		},

		handleNameInputBlur() {
			this.isNameInEditMode = false;
			this.save();
		},
		handleProjectInputBlur() {
			this.isProjectInEditMode = false;
			this.save();
		},

		handleDeleteClick() {
			if (!this.originalSimulation) {
				//fix. use router instead of native location.replace
				window.location.replace("/dashboard");

				return;
			}

			this.deleteSimulation({ id: this.originalSimulation.id })
				.then(() => {
					this.$router.push({
						name: "Dashboard",
					});
				})
				.catch((err) => {
					this.$notify({
						type: "error",
						message: "Erro ao apagar simulação",
					});
				});
		},

		handleDuplicateClick() {
			this.duplicateSimulation({ id: this.originalSimulation.id })
				.then(({ id }) => {
					this.$router.push({
						name: "Simulator",
						params: {
							simulation: id,
						},
					});
				})
				.catch((err) => {
					this.$notify({
						type: "error",
						message: "Erro ao duplicar simulação",
					});
				});
		},

		handleEditDetailsClick() {
			this.isEditDetailsModalOpen = true;
		},

		handleSaveDetails({ simulationName, project }) {
			this.isEditDetailsModalOpen = false;
			this.save();
		},

		save() {
			if (
				this.simulationName === this.simulation.name &&
				this.project === this.simulation.project
			) {
				return;
			}

			this.$NProgress.start();

			this.setSimulationName(this.simulationName);
			this.setSimulationProject(this.project);

			const actionPromise =
				this.simulation.id === "new"
					? this.storeSave()
					: this.storeSaveMetadata();

			actionPromise
				.then(() => {
					history.replaceState(null, null, `/simulator/${this.simulation.id}`);
				})
				.catch((err) => {
					this.$notify({
						type: "error",
						message: "Erro ao salvar simulação",
					});

					this.simulationName = this.simulation.name;
					this.project = this.simulation.project;
				})
				.finally(() => {
					this.$NProgress.done();
				});
		},
	},

	created() {
		this.simulationName = this.simulation.name;
		this.project = this.simulation.project;
	},
};
</script>

<style lang="scss">
.toolbar {
	padding: 30px 40px;
	border-radius: 16px;
	background-color: hsl(0, 0%, 100%);
	display: flex;
	align-items: center;
	gap: 1rem;
	justify-content: space-between;
	flex-wrap: wrap;
}

.toolbar__fields {
	align-items: center;
	display: flex;
	column-gap: 4rem;
	flex-wrap: wrap;
	row-gap: 2rem;
}

.toolbar__fieldLabel {
	font-size: var(--font-size-2xs);
	font-weight: var(--font-weight-bold);
	letter-spacing: 2px;
	text-transform: uppercase;
	color: var(--color-neutral-400);
}

.toolbar__input {
	font-size: var(--font-size-l);
	color: var(--color-neutral-900);
	border-block-end: 1px solid transparent;

	&:not([readonly]):focus {
		border-block-end-color: var(--color-neutral-900);
	}
}

.toolbar__desktopBtns {
	display: flex;
	justify-content: flex-end;
	gap: 15px;
}

.addProjectField {
	position: relative;
	margin: -13px -16px;
}

.addProjectField__input {
	width: 100%;
	padding: 13px 16px;
}

.addProjectField__icon {
	position: absolute;
	right: 16px;
	top: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: var(--font-size-l);
}

.toolbar__mobileMenuDropdown,
.toolbar__mobileStatusBadge {
	display: none;
}

@media (max-width: 960px) {
	.toolbar {
		padding-inline: 20px;
		padding-block: 20px;
	}
	.toolbar__projectFieldBlock,
	.toolbar__editBtn,
	.toolbar__desktopBtns,
	.toolbar__desktopStatusBadge {
		display: none;
	}

	.toolbar__mobileMenuDropdown,
	.toolbar__mobileStatusBadge {
		display: inline-flex;
	}

	.toolbar__input {
		letter-spacing: -0.8px;
	}
}
</style>
